// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CategoryForm.css */

/* Container for the form and table */
.container11 {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

/* Heading styles */
.heading {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
}

/* Form styles */
.categoryForm {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.group {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  max-width: 500px;
}

.inp {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-sizing: border-box;
}

.bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #28a745;
  transition: transform 0.3s ease;
}

.highlight {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #28a745;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.inp:focus ~ .bar,
.inp:focus ~ .highlight {
  transform: scaleX(1);
}

.labl {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 16px;
  color: #999;
  transition: all 0.3s ease;
}

.inp:focus ~ .labl,
.inp:not(:placeholder-shown) ~ .labl {
  top: -20px;
  font-size: 12px;
  color: #28a745;
}

.category-button {

  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.category-button:hover {
  background-color: #218838;
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f4f4f4;
}

/* Confirm dialog styles */
.confirm-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.confirm-dialog {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.confirm-button,
.cancel-button {
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 5px;
  margin: 10px;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.confirm-button {
  background-color: #28a745;
  color: white;
}

.cancel-button {
  background-color: #dc3545;
  color: white;
}

.confirm-button:hover {
  background-color: #218838;
}

.cancel-button:hover {
  background-color: #c82333;
}

/* Responsive design */
@media only screen and (max-width: 600px) {
  .container11 {
    padding: 10px;
  }

  .inp {
    font-size: 14px;
  }

  .labl {
    font-size: 14px;
  }

  .confirm-dialog {
    width: 90%;
    padding: 15px;
  }
}

@media only screen and (max-width: 400px) {
  .category-button {
    font-size: 14px;
    padding: 8px 16px;
  }

  .confirm-button,
  .cancel-button {
    font-size: 14px;
    padding: 8px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Admin/categoryUpload/CategoryForm.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB,qCAAqC;AACrC;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* CategoryForm.css */\n\n/* Container for the form and table */\n.container11 {\n  padding: 20px;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n/* Heading styles */\n.heading {\n  font-size: 24px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n/* Form styles */\n.categoryForm {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.group {\n  position: relative;\n  margin-bottom: 20px;\n  width: 100%;\n  max-width: 500px;\n}\n\n.inp {\n  width: 100%;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-sizing: border-box;\n}\n\n.bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #28a745;\n  transition: transform 0.3s ease;\n}\n\n.highlight {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #28a745;\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.inp:focus ~ .bar,\n.inp:focus ~ .highlight {\n  transform: scaleX(1);\n}\n\n.labl {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  font-size: 16px;\n  color: #999;\n  transition: all 0.3s ease;\n}\n\n.inp:focus ~ .labl,\n.inp:not(:placeholder-shown) ~ .labl {\n  top: -20px;\n  font-size: 12px;\n  color: #28a745;\n}\n\n.category-button {\n\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s ease;\n}\n\n.category-button:hover {\n  background-color: #218838;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\nth, td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\nth {\n  background-color: #f4f4f4;\n}\n\n/* Confirm dialog styles */\n.confirm-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.confirm-dialog {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.confirm-button,\n.cancel-button {\n  border: none;\n  cursor: pointer;\n  padding: 10px 20px;\n  border-radius: 5px;\n  margin: 10px;\n  font-size: 16px;\n  transition: background-color 0.3s ease;\n}\n\n.confirm-button {\n  background-color: #28a745;\n  color: white;\n}\n\n.cancel-button {\n  background-color: #dc3545;\n  color: white;\n}\n\n.confirm-button:hover {\n  background-color: #218838;\n}\n\n.cancel-button:hover {\n  background-color: #c82333;\n}\n\n/* Responsive design */\n@media only screen and (max-width: 600px) {\n  .container11 {\n    padding: 10px;\n  }\n\n  .inp {\n    font-size: 14px;\n  }\n\n  .labl {\n    font-size: 14px;\n  }\n\n  .confirm-dialog {\n    width: 90%;\n    padding: 15px;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .category-button {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n\n  .confirm-button,\n  .cancel-button {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
